import React from 'react'
import RegisterContainer from './RegisterContainer'

export default function Register () {
  return (
    <>
        <RegisterContainer />
    </>
  )
}
